module.exports = __webpack_public_path__ + "media/homeVideo.6cce7d80.mp4";